<div class="apollo-main graphic-comparison">
    <!--  -->
    <header>
        <div class="data-header">
            <h2>Compare graphics</h2>
            <core-helpers-forms-button-white class="compare-action" [text]="'Previous'" (submit)="returnToUpload()" *ngIf="status == 1 || status == 2" [disabled]="showModal"></core-helpers-forms-button-white>
            <p>You can inspect the documents at the graphic level, register them and measure distances.</p>
        </div>
    </header>

    <!-- /////////////// INSTRUCTIONS ///////////// -->
    <div class="instructions">
        <a (click)="show = !show" class="trigger" [ngClass]="{'opened' : show == true}"><em>How does this work?</em></a>
        <ol *ngIf="show">
            <li>You can <strong>align</strong> your <strong>files</strong>.</li>
            <li>Now you can <strong>compare</strong> them.</li>
            <li>Use the <strong>inspector</strong> to see the details.</li>
            <li>Adjust  <strong>opacity</strong>, <strong>zoom</strong> and <strong>quality</strong> of your <strong>files</strong>.</li>
        </ol>
    </div>

    <!--  ////// -->
    <core-helpers-box-alert-button *ngIf="!apolloReady" [text]="'Error: files not loaded.'" [buttonText]="'Back to upload'" (action)="returnToUpload()"></core-helpers-box-alert-button>
    <div [hidden]="!apolloReady" class="box-plugin box-tools" >

        <!-- /////////////// TOOLS BAR ///////////// -->
        <div class="tools" #tools>
            <plugin-apollo-helpers-tools-bar (onChange)="changeTool($event)" [disabled]="status != 1 || showModal" [values]="options"></plugin-apollo-helpers-tools-bar>
            <div class="links">
                <ul>
                    <li><a (click)="openTool('layers')" class="trigger " [ngClass]="{'disabled-link' : status != 1 || showModal, 'active-button': viewTool == 'layers'}" (touch)="scrollToTop('layers')"><em>Files</em></a></li>
                    <li><a (click)="openTool('inspector')" class="trigger" [ngClass]="{'disabled-link' : status != 1 || showModal, 'active-button': viewTool == 'inspector'}" (touch)="scrollToTop('inspector')"><em>Inspector</em></a></li>
                    <li><a href="{{reportUrl}}" [ngClass]="{'disabled-link' : status!=1 || !reported}" class="download-report" ><em>Report</em></a></li>
                </ul>
            </div>
        </div>
        <!-- /////////////  END TOOLS BAR ///////////// -->

        <!-- /////////////  INSPECTOR ///////////// -->

        <div [style.display]="viewTool == 'inspector' && status == 1 ? 'block' : 'none'">
            <plugin-apollo-helpers-graphic-inspector [layers]="layers" [(inspector)]="inspector"></plugin-apollo-helpers-graphic-inspector>
        </div>
        <!-- /////////////  INSPECTOR ///////////// -->

        <!-- /////////////  LAYERS ///////////// -->
        <plugin-apollo-helpers-graphic-layers *ngIf="viewTool=='layers' && status==1" [(layers)]="layers" (registerLayer)="newRegister($event)"></plugin-apollo-helpers-graphic-layers>
        <!-- /////////////  INSPECTOR ///////////// -->


        <div class="image-comparison" id="comparison-layer">
            <core-helpers-box-loading *ngIf="status==0"></core-helpers-box-loading>
            <core-helpers-box-alert-try-again *ngIf="status == 3" [text]="'Error when loading the comparison'"></core-helpers-box-alert-try-again>

            <div class="modal" *ngIf="showModal && (status == 1 || status == 2)">
                <plugin-apollo-helpers-modal-align (action)="actionModal($event)"></plugin-apollo-helpers-modal-align>
            </div>

            <!--<div class="buttons-zoom" *ngIf="(status == 1 || status == 2)">
                <core-helpers-forms-button-white (disabled)="options.zoom>95" class="zoom-in" [text]="'+'" (submit)="increaseZoom(5)"></core-helpers-forms-button-white>
                <core-helpers-forms-button-white (disabled)="options.zoom<5" class="zoom-out" [text]="'-'" (submit)="increaseZoom(-5)"></core-helpers-forms-button-white>
            </div> -->
            <div class="buttons-fixed"  *ngIf="(status == 1 || status == 2) && viewTool != 'inspector'">
                <core-helpers-forms-button-white class="compare-action" [text]="buttonAlignText" (submit)="newRegister()"></core-helpers-forms-button-white>
                <core-helpers-forms-button-white class="compare-action" [text]="'Compare'" (submit)="newCompare()" *ngIf="graphic.id_compared == null"></core-helpers-forms-button-white>
                <core-helpers-forms-button-white *ngIf="graphic.id_compared != null" [hidden]="flicker.flickering" class="compare-action" [text]="'Flicker on'" (submit)="startFlick(1)"></core-helpers-forms-button-white>
                <core-helpers-forms-button-white *ngIf="graphic.id_compared != null" [hidden]="!flicker.flickering" class="compare-action" [text]="'Flicker off'" (submit)="stopFlick()"></core-helpers-forms-button-white>
            </div>
            
            <div class="zoom-buttons" *ngIf="(status == 1 || status == 2)">
                <div>
                    <span [ngClass]="{'disabled': options.zoom>95 }" title="Zoom In" (click)="increaseZoom(5)" >
                        <em><strong>+</strong></em>
                    </span>
                    <span [ngClass]="{'disabled': options.zoom<=5 }" title="Zoom Out" (click)="increaseZoom(-5)">
                        <em><strong>-</strong></em>
                    </span>
                </div>
            </div>
            <figure
                *ngIf="status==1"
                #myBounds
                coreSizeMe
                [state]="sizeFigure"
                [monitorHeight]="true"
                (dblclick)="setInspectorPosition($event)"
                draggable="false">

                <!-- reference -->
                <img
                    *ngIf="reference"
                    coreSizeMe
                    [monitorHeight]="true"
                    (resize)="setInspectorReferenceSizes($event)"
                    [src]="reference.url"
                    [hidden]="!reference.visible"
                    [ngStyle]="{'opacity': reference.opacity/100,'width': 'auto', 'height': 'auto', 'zoom.%': options.zoom}"
                />

                <!-- target -->
                <img
                    *ngIf="target"
                    [src]="target.url"
                    [hidden]="!target.visible"
                    [ngStyle]="{'opacity': target.opacity/100,'width': 'auto', 'zoom.%': options.zoom}"
                />

                <!-- compared -->
                <img
                    *ngIf="compared"
                    [src]="compared.url"
                    [hidden]="!compared.visible"
                    [ngStyle]="{'opacity': compared.opacity/100,'width': 'auto', 'zoom.%': options.zoom}"
                />

                <!-- inspector marker -->
                <div
                    [style.display]="viewTool == 'inspector' ? 'block' : 'none'"
                    ngDraggable
                    (movingOffset)="onInspectorMarkerMoving($event)"
                    (started)="onInspectorMarkerMove(true)"
                    (stopped)="onInspectorMarkerMove(false)"
                    [position]="{x: inspector.marker.left, y: inspector.marker.top}"
                    [bounds]="myBounds"
                    [inBounds]="true"
                    [preventDefaultEvent]="true"
                    [ngStyle]="{'width.px': inspector.marker.width, 'height.px': inspector.marker.height}"
                    class="marker-rectangle"
                >
                <!-- 'top.px': inspector.marker.top, 'left.px': inspector.marker.left,  -->
                    <a (touchstart)="scrollToTop('tools')"></a>
                </div>

                <!-- <img
                    *ngFor="let lay of layers"
                    src="{{lay.url}}"
                    [hidden]="!lay.visible"
                    [ngStyle]="{'opacity': lay.opacity/100,'width': auto, 'zoom.%': options.zoom}"
                /> -->
            </figure>

        </div>
    </div>
    <footer>
        <core-helpers-forms-button-white class="compare-action" [text]="'Previous'" (submit)="returnToUpload()" *ngIf="status == 1 || status == 2" [disabled]="showModal"></core-helpers-forms-button-white>
    </footer>
</div>
